import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isEmptyField, isInvalidEmail } from '../../../utils';
import { useSession } from '../../../hooks';
import { Login } from '../../../dtos';
import { Button, Input, InputPassword } from '../../../components';
import { AuthLayout } from '../../../components/layouts';
import { Container } from './styles';

type FormData = {
    email?: string;
    password?: string;
}

type FormError = {
    field: string;
    message: string;
}

const LoginPage: React.FC = () => {
    const { state } = useLocation() as {
        state: {
            email?: string;
        } | null
    };
    const { authenticateUser } = useSession();
    const [data, setData] = useState<FormData>({
        email: state?.email
    });
    const [errors, setErrors] = useState<FormError[]>([]);

    const handleChange = useCallback((newData: FormData) => setData(oldData => ({
        ...oldData,
        ...newData
    })), []);

    const validateData = useCallback((): Login | null => {
        const { email, password } = data;

        setErrors([]);

        let error: boolean = false;

        if (isEmptyField(email)) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'email',
                message: 'Campo obrigatório'
            }]);
            error = true;
        } else if (isInvalidEmail(email)) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'email',
                message: 'E-mail inválido'
            }]);
            error = true;
        }

        if (isEmptyField(password)) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'password',
                message: 'Campo obrigatório'
            }]);
            error = true;
        }

        return error ? null : ({
            username: email as string,
            password: password as string
        });
    }, [data]);

    const handleLogin = useCallback(async () => {
        const login = validateData();

        if (login) {
            await authenticateUser(login);
        }
    }, [validateData, authenticateUser]);
    
    return (
        <AuthLayout>
            <Container>
                <form>
                    <Input
                        id="login.email"
                        type="email"
                        label="E-mail"
                        placeholder="Digite seu e-mail"
                        defaultValue={state?.email}
                        error={errors.filter(({ field }) => field === 'email')[0]?.message}
                        onChange={e => handleChange({
                            email: e.target.value
                        })}
                        autoFocus={state === null}
                    />
                    <InputPassword
                        id="login.password"
                        label="Senha"
                        placeholder="Digite sua senha"
                        error={errors.filter(({ field }) => field === 'password')[0]?.message}
                        onChange={e => handleChange({
                            password: e.target.value
                        })}
                        autoFocus={state !== null}
                    />
                </form>
                <Button
                    id="login.enterbutton"
                    onClick={handleLogin}
                >
                    Entrar
                </Button>
            </Container>
        </AuthLayout>
    );
};
export { LoginPage };